export { default as LoyaltyLogoWidget } from './loyalty-logo-widget';
